// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "tbody tr[data-v-6785a320]:hover {\n  background-color: transparent !important;\n}\ntbody td[data-v-6785a320] {\n  min-width: 60px;\n}\n.value-field[data-v-6785a320] {\n  font-weight: normal !important;\n  font-size: 12px !important;\n}\n.fs-10[data-v-6785a320] {\n  font-size: 10px !important;\n}", ""]);
// Exports
module.exports = exports;
